import "./App.css";
import { ConfigProvider } from "antd";
import Routes from "./Routes";
import "react-quill/dist/quill.snow.css";
function App() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: "#ffffff",
            bodyBg: "#F5F5F5",
          },
          Menu: {
            itemBg: "#ffffff",
            darkItemBg: "#ffffff",
            darkItemColor: "#919DA9",
            darkItemSelectedBg: "#cfe9f5ff",
            darkItemSelectedColor: "#63B8DE", // changed from #DF1F26 to #63B8DE
            darkItemHoverBg: "#cfe9f5ff",
            darkItemHoverColor: "#63B8DE", // changed from #DF1F26 to #63B8DE
            itemColor: "#919DA9",
            itemSelectedBg: "#cfe9f5ff",
            itemSelectedColor: "#63B8DE",
            itemHoverBg: "#cfe9f5ff",
            itemHoverColor: "#63B8DE",
            itemActiveBg: "#cfe9f5ff",
          },
          Badge: {
            dotSize: 8,
          },
          Table: {
            bodySortBg: "#ffffff",
            headerBg: "#E7E8EE",
            borderColor: "#DBDADE",
            headerColor: "#5d586b",
          },
          Button: {
            colorInfo: "#212180",
            colorFillSecondary: "#212180",
            defaultActiveBg: "#212180",
            colorText: "#212180",
            defaultHoverBorderColor: "#212180",
            defaultActiveColor: "#212180",
            defaultHoverColor: "#212180",
          },
          Input: {
            activeBorderColor: "#212180",
            hoverBorderColor: "#63B8DE"
          },
          Select: {
            activeBorderColor: "#63B8DE",
            hoverBorderColor: "#63B8DE"
          }
        },
        token: {
          colorPrimary: "#63B8DE",
          colorBgContainer: "#00000000",
          headerBg: "#ffffff",
          colorInfoBg: "#212180",
        },
      }}
    >
      <Routes />
    </ConfigProvider>
  );
}

export default App;
